import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from '../../color-constants';

const Container = styled.a`
  text-decoration: none !important;
  box-sizing: content-box;
  min-height: 50px;

  display: flex;
  flex: 1 1 0px;

  background-color: rgba(255, 255, 255, 0.0001);
  ${props => props.selectable ? `
    :hover {
      background-color: #ECEBEB;
      cursor: pointer;
    }
  ` : `pointer-events: none;`}
  transition: background-color .2s;
  border: 1px solid #ECEBEB;
  margin-top: -1px;

  :first-child {
    margin-top: 0px;
  }
`;

const InformationWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  justify-content: space-between;
  align-items: center;
  padding: 10px;

  ${props => props.disabled ? `opacity: 0.6; cursor: default;` : ``}
`;

const Title = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: #626469;
  word-break: break-word;
`;

const FormatWithIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const ExtensionLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  color: ${PRIMARY_COLOR};
  ${props => props.disabled ? `color: #626469;` : ``}
`;

const IconWrapper = styled.div`
  box-sizing: content-box;
   display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  margin-left: 10px;
`;

const DownloadIcon = styled(IconWrapper)`
  color: ${PRIMARY_COLOR};
  border-radius: 2px;
`;

const LoadingSpinner = styled.div`
  box-sizing: content-box;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #636363;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  animation: spin 2s linear infinite;
  margin: 0px;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

class DocumentationLink extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    onDownload: PropTypes.func.isRequired,
    documentGroup: PropTypes.object.isRequired,
    documentUrl: PropTypes.string,
    getLabel: PropTypes.func.isRequired,
    hideIcon: PropTypes.bool,
    icon: PropTypes.string
  }

  getExtensionLabel = (files) => {
    let result;
    if (files.length === 0) {
      result = this.props.getLabel('documentation.not_available')
    } else if (files.length === 1) {
      result = (files[0].extension || '').toLowerCase();
    } else {
      result = '.zip';
    }

    return result;
  }

  render = () => {
    const files = (this.props.documentGroup.get('group') || []);
    const isDisabled = (this.props.documentGroup.get('group') || []).length === 0;
    const isSelectable = !this.props.loading && !isDisabled;
    const extensionLabel = this.getExtensionLabel(files);
    return (
      <Container rel="noopener noreferrer" target="_blank" href={this.props.documentUrl} selectable={isSelectable} onClick={() => { this.props.onDownload(extensionLabel); }}>
        <InformationWrapper disabled={!this.props.loading && isDisabled}>
          <Title>{this.props.name}</Title>
          <FormatWithIconWrapper>
            {this.props.loading ? <LoadingSpinner></LoadingSpinner> : <ExtensionLabel disabled={isDisabled}>{this.getExtensionLabel(files)}</ExtensionLabel>}
            {(isSelectable && !this.props.hideIcon) && <DownloadIcon>
              <qds-icon name={this.props.icon || 'arrow-down-tray'}></qds-icon>
            </DownloadIcon>}
          </FormatWithIconWrapper>
        </InformationWrapper>
      </Container>
    );
  }
}

export default DocumentationLink;
